// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__lkehN","tab":"Tabs_tab__r1Ss6","tabName":"Tabs_tabName__AUkAt"};